export default __webpack_public_path__ + "static/media/montenegro.d201feac.png";